import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { PicSlide } from './picSlide';
import { PicOver } from './picover';
import { PicMask } from './picMask';
import { RecommendSlide } from './recommendSlide';
import { BookRecommendSlide } from './bookRecommendSlide';
import { ShareBox } from './shareBox';
import { Caption } from './caption';
import { addEventListener, debounce, Event } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import Ad, { handleAd } from '@ifeng/ui_pc_ad';
import { requestTongji } from './../../../../services/api';
import Affix from '../affix';

const getWindowWidth = () => {
    if (window.innerWidth !== undefined) {
        return window.innerWidth;
    } else {
        const B = document.body;
        const D = document.documentElement;

        return Math.min(D.clientWidth, B.clientWidth);
    }
};

const getHeight = () => {
    if (window.innerHeight !== undefined) {
        return window.innerHeight;
    } else {
        const B = document.body;
        const D = document.documentElement;

        return Math.min(D.clientHeight, B.clientHeight);
        // return Math.min(947, 947);
    }
};

const LoadPPLive = Loadable({
    loader: () => import('./ppLive'),
    loading() {
        return <div />;
    },
});

const event = new Event();

const LoadComment = Loadable({
    loader: () => import('@ifeng/ui_pc_comment'),
    loading() {
        return <div />;
    },
});

class Content extends React.PureComponent {
    leftRef = React.createRef();
    rightRef = React.createRef();

    state = {
        // 当前幻灯
        current: 0,
        // 幻灯图片总数
        total: this.props.slideData ? this.props.slideData.length : 0,
        // 改变幻灯视图
        changeView: 'normal',
        // 播放器播放暂停状态
        videoPlay: false,
        // 自适应高度
        picCurrentH: 0,
        picContainerH: 0,
        maskH: 0,
        sH: 0,
    };

    async componentDidMount() {
        this.unhandleKeyDown = addEventListener(window, 'keydown', this.handleKeyDown);
        this.unresizePic = addEventListener(window, 'resize', this.debounceFn);
        this.unhashchange = addEventListener(window, 'hashchange', this.changePage);
        this.changePage();
        this.resizePic();

        try {
            const { floatAd3 } = this.props.content;

            const callback = await handleAd(floatAd3);

            callback(floatAd3.data, event);
        } catch (e) {
            console.error(e);
        }
    }

    componentWillUnmount() {
        this.unhandleKeyDown();
        this.unresizePic();
        this.unhashchange();
        this.changePage();
        this.resizePic();
    }

    // 页面刷新，hash改变刷新
    changePage = () => {
        const { total, changeView } = this.state;
        const href = window.location.href;
        const hrefArr = href.split('#');

        if (hrefArr.length > 1 && hrefArr[1].indexOf('p') !== -1) {
            const page = parseInt(hrefArr[1].split('=')[1]);

            if (page <= total) {
                if (changeView === 'isOver') {
                    // 最后一帧推广翻页处理
                    this.setState({ current: page - 1, changeView: 'normal' });
                } else {
                    // 页码范围内翻页处理
                    this.setState({ current: page - 1, changeView, videoPlay: false });
                }
            } else if (page >= total + 1) {
                // 最后一帧推广 url不带&自动补全
                window.location.hash = `#p=${total + 1}&_cpb_slide_last`;
                this.setState({ current: total - 1, changeView: 'isOver' });
            } else if (`${page}`.indexOf('&') !== -1) {
                // 最后一帧推广 url中带&
                this.setState({ current: total - 1, changeView: 'isOver' });
            } else {
                // 页码大于总页数+1时
                this.setState({ current: total - 1, changeView });
            }
        } else {
            // 没有指定页码时，默认为p=1
            window.location.hash = '#p=1';
        }
        // 每一个图片尺寸不一样
        this.resizePic();
    };

    // 监听屏幕尺寸变化,窗口大小改变，图片高度自适应
    resizePic = () => {
        const { current } = this.state;
        const { slideData } = this.props;
        // ie8不支持获取窗口大小
        // const sW = getWindowWidth();
        const sH = getHeight();
        const bH = 735;
        const bW = 1198; // 大图预览幻灯宽度

        // console.log('sH__', sH);
        // const isIE8 = !!window.ActiveXObject && !!document.documentMode;

        const picH = current < this.state.total ? slideData[current].height : '';
        const picW = current < this.state.total ? slideData[current].width : '';

        if (sH > 528 && sH < 845) {
            const h = sH - 45 - 97 - 19 - 80; // 普通幻灯盒子高度
            const w = 870; // 普通幻灯盒子宽度

            // 判断图片比例, 决定缩放高度还是宽度
            if (picH / picW > h / w && picH > h) {
                // 高度优先，图片高度大于盒子高度，缩放
                this.setState({ picCurrentH: h, picContainerH: h });
            } else if (picH / picW > h / w && picH <= h) {
                // 高度优先，图片高度小于盒子高度，图片在里边
                this.setState({ picCurrentH: 'auto', picContainerH: h });
            } else if (picW > w) {
                // 宽度优先，图片宽度大于盒子宽度，缩放
                this.setState({ picCurrentH: (w * picH) / picW, picContainerH: h });
            } else {
                // 宽度优先，图片宽度小于盒子宽度，图片在里边
                this.setState({ picCurrentH: 'auto', picContainerH: h });
            }

            // if (picH >= h) {
            //     // 判断870*比例得到的高度<h
            //     if (h > (870 * picH) / picW) {
            //         this.setState({ picCurrentH: (870 * picH) / picW, picContainerH: h });
            //     } else {
            //         this.setState({ picCurrentH: h, picContainerH: h });
            //     }
            // } else if (isIE8 === true) {
            //     this.setState({ picCurrentH: picH, picContainerH: h });
            // } else {
            //     this.setState({ picCurrentH: 'auto', picContainerH: h });
            // }
            // if (sH > (1198 * picH) / picW) {
            //     this.setState({ maskH: (1198 * picH) / picW, sH });
            // } else {
            //     this.setState({ maskH: sH, sH });
            // }
        } else if (sH < 529) {
            this.setState({ picCurrentH: 'auto', picContainerH: 786 - 45 - 97 - 19 - 80 });
        } else {
            this.setState({ picCurrentH: 'auto', picContainerH: 600 });
        }

        if (picH / picW > bH / bW && picH > bH) {
            // 高度优先，图片高度大于盒子高度，缩放
            this.setState({ maskH: bH, sH });
        } else if (picH / picW > bH / bW && picH <= bH) {
            // 高度优先，图片高度小于盒子高度，图片在里边
            this.setState({ maskH: 'auto', sH });
        } else if (picW > bW) {
            // 宽度优先，图片宽度大于盒子宽度，缩放
            this.setState({ maskH: (bW * picH) / picW, sH });
        } else {
            // 宽度优先，图片宽度小于盒子宽度，图片在里边
            this.setState({ maskH: 'auto', sH });
        }
    };
    debounceFn = debounce(this.resizePic, 100);

    // 上一页
    handlePicPrev = () => {
        const { current } = this.state;

        if (current > 0) {
            window.location.hash = `#p=${current}`;
            // 翻页发送统计
            window.analytics(encodeURIComponent(window.location.href));

            event.trigger('change', {
                leftContainer: this.leftRef.current,
                rightContainer: this.rightRef.current,
                status: 'yes',
            });
        }
    };

    // 下一页
    handlePicNext = () => {
        const { current, total } = this.state;

        if (current < total - 1) {
            window.location.hash = `#p=${current + 2}`;
            event.trigger('change', {
                leftContainer: this.leftRef.current,
                rightContainer: this.rightRef.current,
                status: 'yes',
            });
        } else {
            window.location.hash = `#p=${total + 1}&_cpb_slide_last`;
            event.trigger('change', {
                leftContainer: this.leftRef.current,
                rightContainer: this.rightRef.current,
                status: 'no',
            });
        }

        window.analytics(encodeURIComponent(window.location.href));
    };

    // 打开全屏
    handleBigOpen = () => {
        this.setState({ changeView: 'isBig' });
        // 打开全屏发送统计
        requestTongji('pic', 'f_scr');
    };

    // 关闭全屏
    handleBigClose = () => {
        this.setState({ changeView: 'normal', videoPlay: false });
        // 关闭全屏发送统计
        requestTongji('pic', 'c_scr');
    };

    // 最后一帧，上一页
    handleOverPrev = () => {
        window.location.hash = `#p=${this.state.current + 1}`;
        window.analytics(encodeURIComponent(window.location.href));
        event.trigger('change', {
            leftContainer: this.leftRef.current,
            rightContainer: this.rightRef.current,
            status: 'yes',
        });
    };

    // 最后一页，下一图集
    handleOverNext = () => {
        const { preSlide, url, id } = this.props.docData;
        let nextUrl = '';
        let nextId = '';

        if (preSlide && preSlide.url) {
            nextUrl = preSlide.url;
            nextId = preSlide.id;
        } else {
            nextUrl = url;
            nextId = id;
        }

        window.location.href = `${nextUrl}?_cpb_slide_next&_cpb_slide_next_2`;
        window.analytics(encodeURIComponent(window.location.href));
    };

    // 区域范围内点击翻页
    // handleAreaClick = e => {
    //     let l = (document.body.clientWidth * 1) / 3;
    //     let r = (document.body.clientWidth * 2) / 3;

    //     if (e.pageX < l) {
    //         this.handlePicPrev();
    //     }
    //     if (e.pageX > r) {
    //         this.handlePicNext();
    //     }
    // };
    // 键盘左右方向键切换和全屏退出功能
    handleKeyDown = e => {
        if (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 27) {
            e.preventDefault();
        }
        const { current, total, changeView } = this.state;

        if (e.keyCode === 37) {
            if (changeView === 'isOver') {
                this.handleOverPrev();
            } else {
                this.handlePicPrev(current);
            }
        } else if (e.keyCode === 39) {
            if (changeView === 'isOver') {
                // 下一个图集
                this.handleOverNext();
            } else {
                this.handlePicNext(current, total);
            }
        } else if (e.keyCode === 27) {
            this.handleBigClose();
        } else {
            return;
        }
    };

    // 视频播放
    handleVideoPlay = () => {
        this.setState({ videoPlay: true });
    };
    /**
     * 渲染网页布局
     */
    render() {
        const { changeView, current, videoPlay, picCurrentH, picContainerH, maskH, sH, total } = this.state;
        const { content, docData, slideData, recommendData, bookRecommendData } = this.props;

        const { floatAd3, floatAd5, ppxAd } = content;
        const affixAdData = {
            floatAd3,
            floatAd5,
            ppxAd,
        };

        const { asideAd1, infoAd, hardAd2, asideAd2, hardAd1, infoAd5, logoPPX } = content;

        // 软广
        const adData = {
            infoAd5,
        };

        const { allowComment, commentUrl, title, url, editorName, editorCode, channel, skey, isFo } = docData;
        const commentConfig = {
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl: url,
            // 获取评论内容接口
            cmtNumUrl: '//comment.ifeng.com/get.php',
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: '//comment.ifeng.com/post.php',
            // 最热评论数量
            hotLimit: 3,
            // 评论区域的高度限制
            limitHeight: '310px',
            // 推荐评论接口
            cmtVoteUrl: '//comment.ifeng.com/vote.php',
            // 现实回复的楼层
            replyLimit: 5,
            // 举报提交接口
            jubUrl: '//comment.ifeng.com/report',
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            // 是否允许评论
            allowComment,
        };

        const picMaskData = {
            slideData,
            videoPlay,
            current,
            maskH,
            sH,
            total,
        };

        const picOverData = {
            current,
            channel,
            asideAd2,
        };

        const picSlideData = {
            slideData,
            total,
            videoPlay,
            current,
            picCurrentH,
            picContainerH,
        };

        const Slide = state => {
            switch (state) {
                case 'isBig':
                    return (
                        <PicMask
                            picMaskData={picMaskData}
                            handlePicPrev={this.handlePicPrev}
                            handlePicNext={this.handlePicNext}
                            handleBigClose={this.handleBigClose}
                            handleVideoPlay={this.handleVideoPlay}
                            resizePic={this.debounceFn}
                            // handleAreaClick={this.handleAreaClick}
                        />
                    );
                case 'isOver':
                    return (
                        <PicOver
                            picOverData={picOverData}
                            handleOverPrev={this.handleOverPrev}
                            handleOverNext={this.handleOverNext}
                        />
                    );
                default:
                    return (
                        <PicSlide
                            picSlideData={picSlideData}
                            handlePicPrev={this.handlePicPrev}
                            handlePicNext={this.handlePicNext}
                            handleBigOpen={this.handleBigOpen}
                            handleVideoPlay={this.handleVideoPlay}
                            // handleAreaClick={this.handleAreaClick}
                        />
                    );
            }
        };

        return (
            <div onKeyDown={this.handleKeyDown}>
                <div className={styles.hdpTit}>
                    <Caption docData={docData} changeView={changeView} />
                    <ShareBox docData={docData} logoPPX={logoPPX} />
                </div>
                {Slide(changeView)}
                {changeView === 'isOver' ? (
                    <div className={changeView === 'isOver' ? styles.hardAd : styles.showOff}>
                        <Ad content={hardAd1} styleName={!isFo ? styles.hardAd : styles.showOff} />
                    </div>
                ) : (
                    <div>
                        <RecommendSlide
                            recommendData={recommendData}
                            changeView={changeView}
                            adData={adData}
                            isFo={isFo}
                        />
                        {!isFo ? <BookRecommendSlide bookRecommendData={bookRecommendData} /> : ''}
                    </div>
                )}
                {/* {ppxAd && !isFo ? (
                    <LazyLoad>
                        <LoadPPLive title="泡泡直播" tag="slide_ppposiiton_live1" content={ppxAd} />
                    </LazyLoad>
                ) : (
                    ''
                )} */}
                <div className={changeView === 'isOver' ? styles.showOff : ''}>
                    <div className={styles.comment_box}>
                        <Ad content={asideAd1} styleName={!isFo ? styles.commentAd : styles.showOff} />
                        <div className={styles.commentL}>
                            <LazyLoad>
                                <LoadComment articleInfo={commentConfig} />
                            </LazyLoad>
                        </div>
                    </div>
                    <Ad content={infoAd} styleName={!isFo ? styles.hardAd : styles.showOff} />
                    <div className={styles.zrb}>{editorName ? `[责任编辑：${editorName} ${editorCode}]` : ''}</div>
                    {/* 2.26删除通栏二广告 */}
                    {/* <Ad content={hardAd2} styleName={!isFo ? styles.commomAd : styles.showOff} /> */}
                </div>
                <Affix content={affixAdData} leftRef={this.leftRef} rightRef={this.rightRef} />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Content.propTypes = {
    docData: PropTypes.object,
    slideData: PropTypes.array,
    recommendData: PropTypes.array,
    bookRecommendData: PropTypes.array,
    content: PropTypes.object,
};

/**
 * 定义组件默认属性
 * */
Content.defaultProps = {};

export { Content };
export default errorBoundary(Content);
